enum ExperienceTypeEnum {
  PROFESSIONAL = 'professional',
  DEGREE = 'degree',
  CERTIFICATE = 'certificate',
  TRAINING = 'training',
}

export default ExperienceTypeEnum;
